import {memo} from "react";
import {Modal, Typography} from "antd";
import {TrophyOutlined} from "@ant-design/icons";
import PropTypes from "prop-types";

const {Text} = Typography;

const FinalResultsModal = ({open, winners, onClose}) => (
    <Modal
        open={open}
        onOk={onClose}
        onCancel={onClose}
        title={null}
        centered
        width={600}
        className="draw-modal"
        classNames={{mask: "draw-modal-mask"}}
        okText="Хаах"
        cancelButtonProps={{style: {display: 'none'}}}
        okButtonProps={{size: 'large', className: 'draw-gold-button'}}
    >
        <div className="text-center py-6">
            <img
                src="/happy_pay_2026/1104x400.jpg"
                className="w-full h-[200px] mb-3 rounded-lg object-cover"
                alt="Урамшууллын эзэд"
            />
            <ol className="list-none p-0 m-0 space-y-4">
                {winners.map((winner, index) => (
                    <li
                        key={winner.custno ?? `final-${index}`}
                        className="flex items-center justify-between p-3 rounded-lg"
                        style={{
                            background: 'linear-gradient(90deg, rgba(232, 193, 112, 0.18), rgba(232, 193, 112, 0.06))',
                            border: '1px solid var(--draw-line)',
                        }}
                    >
                        <div className="flex items-center gap-3">
                            <TrophyOutlined aria-hidden="true" style={{color: 'var(--draw-gold)', fontSize: '14px'}}/>
                            <Text strong className="text-md" style={{color: 'var(--draw-text)'}}>{index + 1}) {winner.name}</Text>
                        </div>
                        <Text className="text-xs font-bold" style={{color: 'var(--draw-gold-bright)'}}>
                            {winner.regnum} - {winner.lottery}
                        </Text>
                    </li>
                ))}
            </ol>
        </div>
    </Modal>
);

FinalResultsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    winners: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default memo(FinalResultsModal);
